module.exports = __webpack_public_path__ + "img/67200.8c422da3.jpg";